"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleBarLabel = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var StyledCard = (0, material_1.styled)(material_1.Card)(function () {
    var _a;
    return (_a = {},
        _a["& a"] = {
            textDecoration: 'none',
        },
        _a);
});
var TitleBar = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, titleComponent = _a.titleComponent, centerComponent = _a.centerComponent, actionComponents = _a.actionComponents;
    return (react_1.default.createElement(StyledCard, null,
        react_1.default.createElement(material_1.Box, { px: 3, py: 1.5, justifyContent: "space-between", display: "flex", alignContent: "center", alignItems: "center" },
            react_1.default.createElement(material_1.Box, { py: 0.5 },
                title &&
                    react_1.default.createElement(material_1.Typography, { variant: "h3", color: "primary" }, title),
                titleComponent,
                subtitle &&
                    react_1.default.createElement(material_1.Typography, { variant: "subtitle1", sx: { color: 'rgba(0,0,0,0.66)' } }, subtitle)),
            react_1.default.createElement(material_1.Box, { flexGrow: 1 }, centerComponent),
            react_1.default.createElement(material_1.Box, { margin: 'auto' }, actionComponents.map(function (comp) { return (comp); })))));
};
var TitleBarLabel = function (props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Typography, { variant: "overline", display: "block", sx: {
                fontWeight: '500',
                textTransform: 'capitalize',
                letterSpacing: '0.01em',
                color: 'rgba(0,0,0,0.6)',
                marginBottom: '5px',
                lineHeight: 1
            } }, props.label),
        react_1.default.createElement(material_1.Typography, { variant: 'inherit', sx: {
                lineHeight: '1',
                letterSpacing: '0.01em'
            } }, props.value)));
};
exports.TitleBarLabel = TitleBarLabel;
exports.default = TitleBar;
